<template>
  <div v-if="$store.state.schema['business-partner']">
    <md-button class="md-accent md-dense md-raised download-button" @click="$store.dispatch('getExport', 'partners')">
      Preuzmi
    </md-button>
    <md-table v-if="$store.state.pageLoaded" class="small-table">
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <md-button class="md-icon-button md-raised md-accent" v-on:click="editCreateDialogVisible = true; createDialog = true; $store.state.selectedObject = JSON.parse(JSON.stringify(emptyPartner));" title="Dodaj poslovnog partnera" v-if="$store.state.schema['business-partner'].create">
            <md-icon>add</md-icon>
          </md-button>
          <h1 class="md-title">Poslovni partneri</h1>
        </div>
        <md-field md-clearable class="md-toolbar-section-end search-field">
          <md-icon>search</md-icon>
          <md-input placeholder="Pretraži..." v-model="searchKey"/>
        </md-field>
      </md-table-toolbar>

      <md-table-row v-if="$store.state.receivedData.partners.list.length > 0">
        <md-table-head>Naziv</md-table-head>
        <md-table-head class="t-align-center">Akcije</md-table-head>
      </md-table-row>

      <md-table-row md-selectable="single" md-auto-select v-for="item in $store.state.receivedData.partners.list" v-on:click="$store.state.selectedObject = JSON.parse(JSON.stringify(item))">
        <md-table-cell>{{ item.title }}</md-table-cell>
        <md-table-cell class="actions-cell">
          <md-button class="md-icon-button md-accent" v-on:click="deleteDialog = true" title="Obriši" v-if="$store.state.schema['business-partner'].delete">
            <md-icon>delete</md-icon>
          </md-button>
          <md-button class="md-icon-button" v-on:click="editCreateDialogVisible = true; editDialog = true;" title="Uredi" v-if="$store.state.schema['business-partner'].update">
            <md-icon>edit</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <md-dialog-confirm :md-active.sync="deleteDialog"
                md-title="Brisanje poslovnog partnera"
                md-content="Jeste li sigurni?"
                md-confirm-text="Obriši"
                md-cancel-text="Zatvori"
                v-on:md-confirm="deleteSelected"
                >
    </md-dialog-confirm>

    <md-dialog :md-active.sync="editCreateDialogVisible" v-if="$store.state.selectedObject !== undefined" class="partners-dialog md-scrollbar">
      <md-dialog-title>{{ getDialogTitle }}</md-dialog-title>
      <md-card>
        <md-card-content>
          <div class="md-layout">
            <md-field :class="messageClass('title', $store.state.selectedObject)">
              <label>Naziv</label>
              <md-input required type="text" v-model="$store.state.selectedObject.title"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('oib', $store.state.selectedObject)">
              <label>OIB</label>
              <md-input required type="text" v-model="$store.state.selectedObject.oib"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('address', $store.state.selectedObject)">
              <label>Adresa</label>
              <md-input required type="text" v-model="$store.state.selectedObject.address"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('city', $store.state.selectedObject)">
              <label>Grad</label>
              <md-input required type="text" v-model="$store.state.selectedObject.city"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('postal_code', $store.state.selectedObject)">
              <label>Poštanski broj</label>
              <md-input required type="text" v-model="$store.state.selectedObject.postal_code"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <h3>Kontakt osoba/e</h3>
            <div v-for="user, i in $store.state.selectedObject.contact_person" class="full-width">
              <md-field :class="messageClass('first_name', user)">
                <label>Ime</label>
                <md-input required type="text" v-model="user.first_name"/>
                <span class="md-error">Ovo polje je obavezno</span>
              </md-field>
              <md-field :class="messageClass('last_name', user)">
                <label>Prezime</label>
                <md-input required type="text" v-model="user.last_name"/>
                <span class="md-error">Ovo polje je obavezno</span>
              </md-field>
              <md-field :class="messageClass('mobile_phone', user)">
                <label>Broj mobitela</label>
                <md-input required type="text" v-model="user.mobile_phone"/>
                <span class="md-error">Ovo polje je obavezno</span>
              </md-field>
              <md-field>
                <label>Email</label>
                <md-input required type="email" v-model="user.email"/>
              </md-field>
              <md-divider v-if="i < $store.state.selectedObject.contact_person.length - 1"></md-divider>
            </div>
            <md-button class="md-raised md-dense md-accent" v-on:click="addContactPerson">Dodaj osobu</md-button>
          </div>
          <md-dialog-actions>
            <md-button v-on:click="editCreateDialogVisible = false;">Zatvori</md-button>
            <md-button v-on:click="validate" class="md-primary">Spremi</md-button>
          </md-dialog-actions>
        </md-card-content>
      </md-card>
    </md-dialog>
  </div>
</template>

<script>
import ListingMixin from '../../../mixins/listing-mixin.js'
import SearchMixin from '../../../mixins/search-mixin.js'


export default {
  name: 'Partners',
  data(){
    return {
      emptyPartner: {
        title: '',
        oib: '',
        address: '',
        city: '',
        postal_code: '',
        contact_person: [{
          first_name: '',
          last_name: '',
          mobile_phone: '',
          email: '',
        }],
      },
      emptyUserData: {
        first_name: '',
        last_name: '',
        mobile_phone: '',
        email: '',
      },
      requiredFields: ['title', 'oib', 'address', 'city', 'postal_code'],
    }
  },
  mixins: [ListingMixin('partners', 'poslovnog partnera'), SearchMixin('partners', false)],

  methods: {
    validate(){
      this.objectsToValidate = [this.$store.state.selectedObject];
      this.requiredFields = ['title', 'oib', 'address', 'city', 'postal_code'];
      this.formSubmitted();
      if(this.passed){
        this.objectsToValidate = this.$store.state.selectedObject.contact_person;
        this.requiredFields = ['first_name', 'last_name', 'mobile_phone'];
        this.formSubmitted();
        if(this.passed){
          this.createOrUpdate();
        }
      }
    },

    addContactPerson(){
      this.$store.state.selectedObject.contact_person.push(JSON.parse(JSON.stringify(this.emptyUserData)));
    }
  },
}
</script>

<style lang="scss">
.partners-dialog{
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Tickets/Partners.vue